import React, { memo} from 'react'

import { string, bool } from 'prop-types'

import NewLogoSmall from 'images/cg_icon_rgb_small.svg'
import NewLogo from 'images/cgtrader_RGB.svg'

function Logo({ url, isCurrentUser }) {
  const className = isCurrentUser ? 'wayfinder__logo' : 'wayfinder__logo wayfinder__logo--signed-out'
  const sourceMedia = isCurrentUser ? '(min-width: 640px)' : '(min-width: 390px)'

  return (
    <a
      className={className}
      data-track-text=""
      data-track-label="Homepage"
      href={url}
    >
      <picture className="wayfinder__item">
        <source
          media={sourceMedia}
          srcSet={NewLogo}
        />
        <img
          src={NewLogoSmall}
          alt="CGTrader - 3D Models / 3D Designers"
          width="100"
          height="25"
          loading="lazy"
        />
      </picture>
    </a>
  )
}

Logo.propTypes = {
  url: string.isRequired,
  isCurrentUser: bool.isRequired,
}

export default memo(Logo)
